module.exports = __webpack_public_path__ + "img/menu_ht.4434e2d8.png";